
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class AdvancedPromoReportDialog extends Serenity.EntityDialog<AdvancedPromoReportRow, any> {
        protected getFormKey() { return AdvancedPromoReportForm.formKey; }
        protected getIdProperty() { return AdvancedPromoReportRow.idProperty; }
        protected getLocalTextPrefix() { return AdvancedPromoReportRow.localTextPrefix; }
        protected getNameProperty() { return AdvancedPromoReportRow.nameProperty; }
        protected getService() { return AdvancedPromoReportService.baseUrl; }
        protected getDeletePermission() { return AdvancedPromoReportRow.deletePermission; }
        protected getInsertPermission() { return AdvancedPromoReportRow.insertPermission; }
        protected getUpdatePermission() { return AdvancedPromoReportRow.updatePermission; }

        protected form = new AdvancedPromoReportForm(this.idPrefix);

        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            return buttons;


        }
    }
}